import { render } from "./KefuView.vue?vue&type=template&id=9469810e&scoped=true"
import script from "./KefuView.vue?vue&type=script&lang=js"
export * from "./KefuView.vue?vue&type=script&lang=js"

import "./KefuView.vue?vue&type=style&index=0&id=9469810e&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9469810e"]])

export default __exports__